export default "__VITE_ASSET__aZHB6LlI__"